export enum TrophyItemType {
  BOPARTNERPROFILE = "BOPARTNERPROFILE",
  CLICKTHEPIC = "CLICKTHEPIC",
  COMPANYPROFILE = "COMPANYPROFILE",
  JOB = "JOB",
  JOBPORTRAIT = "JOBPORTRAIT",
  PROVIDERQUIZ = "PROVIDERQUIZ",
  QUIZ = "QUIZ",
  SCHOOLPORTRAIT = "SCHOOLPORTRAIT",
  SCHOOLPROFILE = "SCHOOLPROFILE",
  TEACHINGIDEA = "TEACHINGIDEA"

}
